<template>
  <div class="c-input u-w456">
    <div class="p-message-edit-list__item p-message-edit-list__item--set-delivery-action no-margin">
      <div class="optin-condition-prefix u-w100">オプトイン後</div>
      <div class="c-input u-w300 no-margin">
        <input
          v-model="optinDays"
          :name="'optin_days' + inputName"
          class="c-input__item"
          type="text"
          placeholder=""
        />
      </div>
      <div class="optin-condition-prefix u-w40">日</div>
    </div>

    <div class="c-error c-error--balloon">
      <div class="c-error__text"></div>
    </div>
  </div>
</template>

<script>
import 'moment';

export default {
  props: {
    value: String,
    inputName: {
      type: String,
      default: 'optin_condition',
    },
    isError: {
      type: Boolean,
      required: false
    },
    errorMessage: {
      type: String,
      required: false
    },
  },
  emits: ['change'],
  data() {
    return {
      currentValue: this.value,
      optinDays: null,
    }
  },
  watch: {
    optinDays: function (newValue, oldValue) {
      var notNumber = /[^0-9]/g;
      let escapedValue = newValue.replace(notNumber, "");
      if (escapedValue == oldValue) {
        this.optinDays = oldValue;
      } else {
        this.onValueChange();
      }
    },
    value: function (newValue, _oldValue) {
      this.setCurrentValue(newValue);
    }
  },
  mounted: function () {
    this.setCurrentValue(this.currentValue);
  },
  methods: {
    setCurrentValue: function (newValue) {
      this.currentValue = newValue;
      if (this.currentValue) {
        var number = /^\d+$/;
        if (this.currentValue.match(number)) {
          this.optinDays = this.currentValue;
        }
      }
    },
    onValueChange: function () {
      let value;
      // 日
      value = this.optinDays;
      this.currentValue = value;
      this.$emit("change", this.currentValue);
    },
  },
}
</script>
